import { useDeleteCaseTask } from "@/mutations/useDeleteCaseTask.tsx";
import { getErrorMessage } from "@/utils/api.ts";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Typography from "@mui/material/Typography";
import { enqueueSnackbar } from "notistack";
import type React from "react";
import { useState } from "react";

type Props = {
    caseTaskUUID: string;
};

const ConfirmDeleteTaskModal = ({ caseTaskUUID }: Props): React.ReactElement => {
    const [open, setOpen] = useState(false);
    const deleteCaseTask = useDeleteCaseTask();

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = () => {
        if (caseTaskUUID) {
            deleteCaseTask.mutate(
                {
                    caseTaskId: caseTaskUUID,
                },
                {
                    onSuccess: () => {
                        enqueueSnackbar("Case Task removed.", { variant: "success" });
                        setOpen(false);
                    },
                    onError: (error) => {
                        enqueueSnackbar("Error: Case Task could not be removed.", {
                            variant: "error",
                        });
                        console.info("error", getErrorMessage(error));
                    },
                },
            );
        }
    };

    return (
        <>
            {caseTaskUUID && (
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    Delete
                </Button>
            )}
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Delete Task</DialogTitle>
                <DialogContent>
                    <Typography variant="body2">
                        Are you sure you want to delete this task?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ConfirmDeleteTaskModal;
